import React from 'react';
import { Button } from 'antd';
import { useMediaQuery } from 'react-responsive'

export const ResponsiveButton = ({title, icon, showSmallerText, ...props}) => {
  const isMobile =useMediaQuery({ maxWidth: 767 })

  return (
    <Button {...props} size={isMobile && showSmallerText ? "small" : props.size}>
      {(!isMobile || showSmallerText) && title}
      {icon}
    </Button>
  );
}